import * as React from "react";
import Notifications from '@mui/icons-material/Notifications';
import NotificationsActive from '@mui/icons-material/NotificationsActive';
import MuiIconSvg, { MuiIconSvgProps } from "components/MuiExtras/MuiIconSvg";

interface IProps {
    active: boolean;
}

const IconNotify: React.FC<IProps & MuiIconSvgProps> = (props) => {
    const { active, ...rest } = props;
    return <MuiIconSvg {...rest} icon={props.active ? NotificationsActive : Notifications} />
}

export default IconNotify
